import commonService from './common-service';

class OrderEntryService {
  async getOrderValues() {
    try {
      const response = await commonService.getFromServer('Dashboard', {});
      if (response) {
        return response;
      } else {
        throw new Error('Error retrieving details. Please contact administrator.');
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
}

export default new OrderEntryService();
